import Vue from "vue";

export default {
	state: {
		families: {}
	},
	mutations: {
		setFamiliesOnState(state, families) {
			state.families = mapFamilies(families);
		},
		setFamilyChildrenOnState(state, childrens) {
			mapFamiliesAndSetOnState(state, childrens);
		},
		setActualFamilyOnState(state, family) {
			Vue.set(state, "actualFamily", family);
		},
		setStatusOnTree(state) {
			recursiveSetStatus(state.families.children, state.listItensSelected);
		}
	},
	actions: {
		getFamilies({ state, commit }, data) {
			this.state.loading = true;

			if (!data) data = {};
			if (!data.idClient) {
				data.idClient = state.actualUser.idClient;
			}
			const { isIframeContext = false, overwriteSessionStorage, ...filter } = data;

			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/filter/", filter, { isIframeContext })
					.then((response) => {
						if (overwriteSessionStorage) {
							sessionStorage.setItem("originalFamilies", JSON.stringify(response.data.data));
						}
						commit("setFamiliesOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		getStandardFamilies({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/standard/filter/", filter)
					.then((response) => {
						this.state.loading = false;
						commit("setFamiliesOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getFamilyChildrens({ commit }, id) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/childrens/" + id + "/client")
					.then((response) => {
						this.state.loading = false;
						commit("setFamilyChildrenOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getStandardFamilyChildren({ commit }, family) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/standard/" + family.idStandard + "/children/" + family.idFamily)
					.then((response) => {
						this.state.loading = false;
						commit("setFamilyChildrenOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getStandardFamilyParents({ commit }, idStandard) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/standard/" + idStandard + "/parents")
					.then((response) => {
						this.state.loading = false;
						commit("setFamiliesOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},

		getFamily({ commit }, id) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("family/" + id)
					.then((response) => {
						this.state.loading = false;
						commit("setActualFamilyOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		deleteFamily(_, family) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("family/" + family.idFamily)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
						reject(error.response.data.error);
					});
			});
		},
		deleteAllFamilies() {
			this.state.loading = true;

			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("family")
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error);
					});
			});
		},

		createStandardFamily(_, standard) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("family/standard", standard).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		createFamily(_, family) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("family", family)
					.then((response) => {
						this.state.loading = false;
						response.data.isError ? reject(response.data.data.code) : resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		getFamiliesNames(_, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("family/name", id).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		editFamily(_, family) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("family/" + family.idFamily, family)
					.then((response) => {
						this.state.loading = false;
						response.data.isError ? reject(response.data.data.code) : resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		editFamilyOrdenation(_, familyOrdenations) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("family/ordenation", familyOrdenations)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error.response.data.error.message);
					});
			}).catch(() => {
				this.state.loading = false;
			});
		}
	},
	getters: {
		families({ families }) {
			return families;
		},
		actualFamily({ actualFamily }) {
			return actualFamily;
		},
		familiesWithStatus({ families, listItensSelected }) {
			let familyStatus = families;
			if (familyStatus.children) {
				recursiveSetStatus(familyStatus.children, listItensSelected).then(() => {
					return familyStatus;
				});
			}
			return familyStatus;
		}
	}
};

const mapFamiliesAndSetOnState = (state, families) => {
	//Caso não tenha idParentFamily, ele faz parte da raiz
	if (!families[0].idParentFamily) {
		families.forEach((family) => {
			if (!family.status) family.status = "notAdded";
		});
		state.families.children = families;
	}
};

const mapFamilies = (requirementFromBack) => {
	let response = {
		title: null,
		idFamily: 0,
		idParentFamily: 0,
		children: requirementFromBack,
		haveChildren: true,
		isOpen: true
	};
	return response;
};

const recursiveSetStatus = (tree, listFamiliesSelected) => {
	return new Promise((resolve) => {
		const selectedFamilies = Array.isArray(listFamiliesSelected) ? listFamiliesSelected : [listFamiliesSelected];

		tree?.forEach((treeItem) => {
			if (selectedFamilies.find((idFamily) => idFamily == treeItem.idFamily)) {
				Vue.set(treeItem, "status", "added");
				Vue.set(treeItem, "selected", true);
			} else {
				Vue.set(treeItem, "status", "notAdded");
				Vue.set(treeItem, "selected", false);
			}
			if (treeItem.children) {
				recursiveSetStatus(treeItem.children, selectedFamilies).then(() => {
					resolve();
				});
			}
		});
		resolve();
	});
};
